import React, { useEffect, useState } from "react";

import {
  Alert,
  Button,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { faInfoCircle, faPaperPlane } from "@fortawesome/free-solid-svg-icons";

import { toast } from "react-toastify";

import { useNavigate, useSearchParams } from "react-router-dom";

import api from "../../../utils/axiosPublic";

import "./home.scss";

const TrialContactPage = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();

  const [formData, setFormData] = useState({
    fullName: "",

    phone: "",

    message: "",
  });

  const [error, setError] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    document.title = "Kafood | Đăng ký dùng thử";

    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    setError((prev) => ({ ...prev, [field]: "" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.fullName.trim()) {
      setError((prev) => ({ ...prev, fullName: "Vui lòng nhập tên của bạn" }));

      return;
    }

    if (formData.phone.toString().trim().length < 10) {
      setError((prev) => ({
        ...prev,
        phone: "Vui lòng nhập số điện thoại từ 10 chữ số",
      }));

      return;
    }

    try {
      setIsLoading(true);

      const res = await api.post("/customer/create", {
        fullName: formData.fullName.trim(),

        phone: formData.phone.toString().trim(),

        message: formData.message.trim(),

        slug: searchParams.get("slug") || undefined,
      });

      if (res.data.errCode === 0) {
        navigate("/dang-ky-thanh-cong");

        toast("Đăng ký thành công", {
          type: "success",

          autoClose: 1000,

          style: { marginTop: "50px" },
        });
      }
    } catch (error) {
      setError(error.response?.data?.messages || {});

      toast("Đăng ký thất bại", {
        type: "error",

        autoClose: 1500,

        style: { marginTop: "50px" },
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="detail_bg trial-contact-page">
      <div className="text_title">
        <h1>ĐĂNG KÝ DÙNG THỬ KAFOOD</h1>
      </div>

      <Container className="trial-contact-container">
        <Row className="justify-content-center">
          <Col lg={7} xl={6}>
            <div className="trial-contact-panel">
              <Alert variant="primary" className="trial-contact-alert">
                <FontAwesomeIcon
                  className="text-primary me-1"
                  icon={faInfoCircle}
                />
                Hãy để lại thông tin. Tư vấn viên Kafood sẽ liên hệ với bạn
                trong thời gian sớm nhất!
              </Alert>

              <Form onSubmit={handleSubmit}>
                <Row>
                  <Col md={6}>
                    <Form.Floating className="mb-3">
                      <Form.Control
                        className="form-contact"
                        type="text"
                        name="fullName"
                        placeholder="Tên của bạn"
                        value={formData.fullName}
                        isInvalid={!!error?.fullName}
                        onChange={(e) =>
                          handleChange("fullName", e.target.value)
                        }
                      />

                      <Form.Label>Tên của bạn</Form.Label>

                      <i className="text-danger">{error?.fullName}</i>
                    </Form.Floating>
                  </Col>

                  <Col md={6}>
                    <Form.Floating className="mb-3">
                      <Form.Control
                        className="form-contact"
                        type="text"
                        name="phone"
                        placeholder="Số điện thoại"
                        value={formData.phone}
                        isInvalid={!!error?.phone}
                        onChange={(e) => handleChange("phone", e.target.value)}
                      />

                      <Form.Label>
                        Số điện thoại<i className="text-danger">*</i>
                      </Form.Label>

                      <i className="text-danger">{error?.phone}</i>
                    </Form.Floating>
                  </Col>
                </Row>

                <Form.Floating className="mb-3">
                  <Form.Control
                    className="form-contact"
                    as="textarea"
                    name="message"
                    placeholder="Lời nhắn"
                    value={formData.message}
                    isInvalid={!!error?.message}
                    onChange={(e) => handleChange("message", e.target.value)}
                  />

                  <Form.Label>Lời nhắn</Form.Label>

                  <i className="text-danger">{error?.message}</i>
                </Form.Floating>

                <Button
                  type="submit"
                  variant="success"
                  className="trial-submit-btn"
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <Spinner animation="border" size="sm" />
                  ) : (
                    <FontAwesomeIcon icon={faPaperPlane} />
                  )}{" "}
                  Gửi
                </Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default TrialContactPage;
